import React, { memo, FC } from 'react';
import classNames from 'classnames';
import {
  makeStyles,
  shorthands,
  TableCellLayout,
  Text,
} from '@fluentui/react-components';

export const useStyles = makeStyles({
  textCell: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  textCellContent: {
    display: 'flex',
    alignItems: 'center',
    ...shorthands.gap('8px'),
  },
});

export interface ITextCellProps {
  value: string;
  cellName: string;
}

export const TextCell: FC<ITextCellProps> = memo(({
  value,
  cellName,
}: ITextCellProps) => {
  const classes = useStyles();
  return (
    <TableCellLayout truncate className={classNames(`ba-top-changes-${cellName}-cell`, classes.textCell)} >
      <div className={classNames(`ba-top-changes-${cellName}-cell-content`, classes.textCellContent)}>
        <Text className={`ba-top-changes-${cellName}-cell-value`} size={200} >{value}</Text>
      </div>
    </TableCellLayout>
  );
});
